import { FullPageSpinner } from '@/components/shared/FullPageSpinner/FullPageSpinner';
import { OfflineBoundary } from '@/components/shared/OfflineBoundary/OfflineBoundary';
import { Toaster } from '@/components/ui/Toast/Toast';
import { queryClient } from '@/lib/reactQuery';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Suspense, type PropsWithChildren } from 'react';

export const AppProvider = ({ children }: PropsWithChildren) => {
  return (
    <Suspense fallback={<FullPageSpinner />}>
      <QueryClientProvider client={queryClient}>
        {import.meta.env.VITE_ENVIRONMENT === 'dev' && <ReactQueryDevtools />}
        <OfflineBoundary>{children}</OfflineBoundary>
      </QueryClientProvider>
      <Toaster />
    </Suspense>
  );
};
